import { render, staticRenderFns } from "./SalesRepresentative.vue?vue&type=template&id=5be8ef7e&scoped=true&"
import script from "./SalesRepresentative.vue?vue&type=script&lang=js&"
export * from "./SalesRepresentative.vue?vue&type=script&lang=js&"
import style0 from "./SalesRepresentative.vue?vue&type=style&index=0&id=5be8ef7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8ef7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCard})
